<template>
  <div id="hotel-search-app">
    <div class="filter">
      <div class="spinner loading"><i class="fa fa-spinner"></i></div>
      <div class="main-form hidden">
        <form name="hotel-filters" action="">
          <input id="wp-action" type="hidden" name="action" value="" />
          <div class="filter-title">
            <span>Trova la struttura adatta a te:</span>
            <span class="empty__filters" :class="{ hidden: hideClearFilters }"><a href="#empty" @click.prevent="emptyForm">AZZERA FILTRI</a></span>
          </div>

          <div class="nav nav-pills nav-filter" role="tablist">
            <drop-down
              main-icon="fas fa-home" 
              main-message="Scegli il tipo di struttura"
              mobile-message="Seleziona il tipo delle strutture che vuoi filtrare:"
              category-name="Tipologia"
              plural-category-name=""
              plural-filter=""></drop-down>
            <drop-down 
              main-icon="far fa-dot-circle" 
              main-message="Scegli il tema"
              mobile-message="Seleziona il tema che vuoi filtrare:"
              category-name="Tema"
              plural-category-name=""
              plural-filter=""></drop-down>
            <drop-down 
              main-icon="fas fa-map-marker-alt" 
              main-message="Scegli la località"
              mobile-message="Seleziona la località che vuoi filtrare:"
              category-name="Località"
              plural-category-name=""
              plural-filter=""></drop-down>
          </div>
          <div class="nav nav-pills nav-filter" role="tablist">
            <drop-down-exploded
              multiple
              main-icon="fas fa-child" 
              main-message="Età bambini"
              mobile-message="Seleziona le età dei bambini che vuoi filtrare:"
              category-name="Fasce Anni"
              plural-category-name="età"
              plural-filter="filtrate"></drop-down-exploded>
          </div>
          <div class="nav nav-pills nav-filter" role="tablist">
            <drop-down-exploded
              multiple columns
              main-icon="fas fa-info-circle" 
              main-message="Deve avere"
              mobile-message="Seleziona le risorse che vuoi filtrare:"
              category-name="Risorse"
              plural-category-name="risorse"
              plural-filter="filtrate"></drop-down-exploded>
          </div>

          <div class="filter-title">
            <span class="empty__filters empty__filters--mobile" :class="{ hidden: hideClearFilters }"><a href="#empty" @click.prevent="emptyForm">AZZERA FILTRI</a></span>
          </div>
          
        </form>
      </div>
    </div>
    <div class="results-number hidden">
      <span>{{ hotelNumberMessage }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import DropDown from './components/DropDown.vue';
import DropDownExploded from './components/DropDownExploded.vue';

export default {
  name: 'hotel-search-app',
  components: {
    "drop-down": DropDown,
    "drop-down-exploded": DropDownExploded
  },
  data: function() {
    return {
      baseUrl: "",
      filteredUrl: "",
      unfilteredUrl: "",
      session: null,
      result: 0,
    };
  },
  created: function() {
    this.$root.$on('add-filter', function(filter) {
      let old_filter = null;
      let i = 0;

      if ( true === filter.$parent.multiple ) {
        for ( i = 0; i < this.$root.filters.length; i++ ) {
          old_filter = this.$root.filters[i];
          if ( filter.taxonomy == old_filter.taxonomy 
            && filter.categoryId == old_filter.categoryId )
          {
            old_filter.changeActive();
            old_filter.changeDisabled();
            old_filter.removeFromStorage();
          }
        }
      }
      else {
        for ( i = 0; i < this.$root.filters.length; i++ ) {
          old_filter = this.$root.filters[i];
          if ( filter.taxonomy == old_filter.taxonomy ) {
            old_filter.changeActive();
            old_filter.changeDisabled();
            old_filter.removeFromStorage();
          }
        }
      }

      if ( !filter.isInStorage() ) {
        filter.addToStorage();
      }

      this.$root.filters.push(filter);
    });

    this.$on('change-selection', function() {
      let $cloned = null;
      this.spinner();
      // eslint-disable-next-line
      let $form = jQuery('form', this.$el);
      // eslint-disable-next-line
      $cloned = $form.clone();
      // eslint-disable-next-line
      jQuery('#wp-action', $cloned).val("familygo_hotels_router");
      // eslint-disable-next-line
      jQuery($cloned).append( '<input type="hidden" name="_nonce" value="' + this.session['familygo_hotels_router'] + '" />' );
      
      if ( $cloned.length > 0 ) {
        // eslint-disable-next-line
        jQuery.post({
          "url": window.ajaxurl,
          "data": $cloned.serialize(),
          "success": (response) => {
            window.dataLayer.push({'action': response.redirectUrl});
            window.dataLayer.push({'event': 'click_filtro_ricerca_struttura'});
            window.location.href = response.redirectUrl;
          }
        });
      }
    });

  },
  mounted: function() {     
    this.session = window.__parameters;
    this.createFilter().then(this.hideSpinner);
    // eslint-disable-next-line
    jQuery('.family-hotel a').click(function() {
      this.spinner();
    }.bind(this));
    // eslint-disable-next-line
    jQuery('.family-hotel.empty-filter').on('click', function() {
      this.$emit('change-selection');
    }.bind(this));
  },
  computed: {
    hideClearFilters: function() {
      return this.$root.filters.length == 0;
    },
    hotelNumberMessage: function() {
      if ( this.result != 1 ) {
        return this.result + ' risultati trovati';
      }
      else {
        return this.result + ' risultato trovato';
      }
    }
  },
  methods: {
    spinner: function() {
      Vue.nextTick(() => {
        // eslint-disable-next-line
        jQuery('.main-form', this.$el).addClass('hidden');
        // eslint-disable-next-line
        jQuery('.spinner', this.$el).addClass('loading');
      });
    },
    hideSpinner: function() {
      Vue.nextTick(() => {
        // eslint-disable-next-line
        jQuery('.spinner', this.$el).removeClass('loading');
        // eslint-disable-next-line
        jQuery('.main-form', this.$el).removeClass('hidden');
      });
    },
    emptyForm: function() {
      let filter = this.$root.filters.pop();
      while( undefined !== filter ) {
          filter.changeActive();
          filter.changeDisabled();
          filter.removeFromStorage();
          filter = this.$root.filters.pop();
      }
      Vue.nextTick(() => {
        window.dataLayer.push({'label': 'remove_selection'});
        window.dataLayer.push({'category': 'emptied_form'});
        this.$emit('change-selection');
      });
    },
    createFilter: function() {
      // eslint-disable-next-line
      let $form = jQuery('<form>');
      let key = '';

      $form.append( '<input type="hidden" name="action" value="familygo_hotels_filters" />' );
      $form.append( '<input type="hidden" name="_nonce" value="' + this.session['familygo_hotels_filters'] + '" />' );

      for( key in this.session ) {
        if ( -1 != key.search('familygo_alloggio_tema') ) {
          $form.append( '<input type="hidden" name="familygo_alloggio_tema[]" value="' + this.session[key] + '" />' );
        }
        if ( -1 != key.search('familygo_alloggio_tipologia') ) {
          $form.append( '<input type="hidden" name="familygo_alloggio_tipologia[]" value="' + this.session[key] + '" />' );
        }
        if ( -1 != key.search('familygo_alloggio_risorsa') ) {
          $form.append( '<input type="hidden" name="familygo_alloggio_risorsa[]" value="' + this.session[key] + '" />' );
        }
        if ( -1 != key.search('familygo_alloggio_fasce_anni') ) {
          $form.append( '<input type="hidden" name="familygo_alloggio_fasce_anni[]" value="' + this.session[key] + '" />' );
        }
        if ( -1 != key.search('familygo_luogo') ) {
          $form.append( '<input type="hidden" name="familygo_luogo[]" value="' + this.session[key] + '" />' );
        }
      }
      // eslint-disable-next-line
      return jQuery.post({
        "url": window.ajaxurl,
        "data": $form.serialize(),
        "success": function(response) {
          this.baseUrl = response.baseUrl;
          this.filteredUrl = response.filteredUrl;
          this.unfilteredUrl = response.unfilteredUrl;
          this.result = response.hotelNumber;
          this.$root.$emit('categories-loaded', response.hotelsCategory);
          // eslint-disable-next-line
          jQuery('.results-number', this.$el).removeClass('hidden');
        }.bind(this)
      });
    } 
  }
}
</script>